
import { checkBrowserVersion } from './browserVersionCheck';
import { minutVersionConfig } from '../config/browserVersionConfig';

export type WebApiAvailability = {
  isSecureContext: boolean;
  isCryptoAvailable: boolean;
  isGetRandomValuesAvailable: boolean;
  isRandomUUIDAvailable: boolean;
  isSubtleAvailable: boolean;
  isShowFilePickerAvailable: boolean;
  isFileSystemHandleAvailable: boolean;
  isCreateWritableAvailable: boolean;
  isBrowserSupported: boolean;
};

export const checkWebApiAvailability = async () => {
  const isSecureContext = window.isSecureContext || false;
  const isCryptoAvailable = typeof crypto !== 'undefined';
  const isGetRandomValuesAvailable = isCryptoAvailable && typeof crypto.getRandomValues === 'function';
  const isRandomUUIDAvailable = isCryptoAvailable && typeof crypto.randomUUID === 'function';
  const isSubtleAvailable = isCryptoAvailable && !!crypto.subtle; 
  let isShowFilePickerAvailable = false;
  let isFileSystemHandleAvailable = false;
  let isCreateWritableAvailable = false;

  try {
    if ('showSaveFilePicker' in window) {
      isShowFilePickerAvailable = true;
    }

    if ('FileSystemFileHandle' in window) {
      isFileSystemHandleAvailable = true;
    }

    if ('createWritable' in window.FileSystemFileHandle.prototype) {
      isCreateWritableAvailable = true;
    }    
  } catch (error) {
    console.error(error);
  }  

  // Check browser version support
  const browserInfo = checkBrowserVersion(minutVersionConfig);
  const isBrowserSupported = browserInfo.isSupported;

  return {
    isSecureContext,
    isCryptoAvailable,
    isGetRandomValuesAvailable,
    isRandomUUIDAvailable,
    isSubtleAvailable,
    isShowFilePickerAvailable,
    isFileSystemHandleAvailable,
    isCreateWritableAvailable,
    isBrowserSupported
  };
};